if ($('.wp-pagenavi').length) {
  $('.current').prev().addClass('is-show');
  $('.current').next().addClass('is-show');
  // console.log($('current').prev());
} 